import { memo, useEffect, useRef } from "react";

import { SkillInfo } from "./skillsSlice";

import "./Skills.css";

// Menú que aparece sobre el área de texto al escribir "/": lista las
// skills del bot filtradas por lo que sigue a la diagonal. Se navega
// con las flechas y Enter/Tab (el manejo de teclas vive en webChat.tsx,
// que es dueño del textarea) o con clic.
function SkillSlashMenu(props: {
  items: SkillInfo[];
  highlighted: number;
  loaded: boolean;
  onSelect: (skill: SkillInfo) => void;
  onHighlight: (index: number) => void;
}) {
  const listRef = useRef<HTMLDivElement>(null);

  // La opción resaltada siempre queda a la vista al navegar con flechas.
  useEffect(() => {
    const option = listRef.current?.querySelector<HTMLElement>(
      `[data-index="${props.highlighted}"]`
    );
    option?.scrollIntoView({ block: "nearest" });
  }, [props.highlighted]);

  return (
    <div className="skill-menu" role="listbox" aria-label="Skills">
      <div className="skill-menu__header">Skills</div>
      <div className="skill-menu__list" ref={listRef}>
        {props.items.map((skill, index) => (
          <button
            type="button"
            key={skill.name}
            data-index={index}
            role="option"
            aria-selected={index === props.highlighted}
            className={
              index === props.highlighted
                ? "skill-menu__item skill-menu__item--active"
                : "skill-menu__item"
            }
            // mousedown + preventDefault: el textarea no pierde el foco.
            onMouseDown={(event) => {
              event.preventDefault();
              props.onSelect(skill);
            }}
            onMouseEnter={() => props.onHighlight(index)}
          >
            <span className="skill-menu__command">{skill.command}</span>
            <span className="skill-menu__text">
              <span className="skill-menu__title">{skill.title}</span>
              {skill.summary && (
                <span className="skill-menu__summary">{skill.summary}</span>
              )}
            </span>
          </button>
        ))}
        {props.items.length === 0 && (
          <div className="skill-menu__empty">
            {props.loaded ? "No skills match" : "Loading skills..."}
          </div>
        )}
      </div>
      <div className="skill-menu__hint">
        ↑ ↓ to navigate · Enter to select · Esc to close
      </div>
    </div>
  );
}

export default memo(SkillSlashMenu);
